<div
  *ngIf="showFullPageLoader"
  class="full-page-loader-wrapper"
  id="shared-full-page-loader-wrapper"
>
  <app-spinner [diameter]="'medium'" id="shared-full-page-loader-spinner"></app-spinner>
</div>
